import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=1e4358e0&scoped=true"
import script from "./widget.vue?vue&type=script&lang=ts"
export * from "./widget.vue?vue&type=script&lang=ts"
import style0 from "./widget.vue?vue&type=style&index=0&id=1e4358e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4358e0",
  null
  
)

export default component.exports